import React from 'react';
import {useDateInput} from "../inputs";
import Form, {GroupItem, SimpleItem, Label, EmptyItem} from "devextreme-react/form";
import useUsager from "../selectbox/usager";
import {Splitter} from "devextreme-react";
import {format} from "date-fns";

export default function FormSysteme(formData: any) {
    const {dateOptions: dateTimeOptions} = useDateInput(true);
    const {getUsagerNamebyId} = useUsager();

    return (
        <div style={{display: "Flex", flexDirection: "column"}}>
            <div className={"dx-field-item-label-text"} style={{
                display: "flex",
                flexDirection: "column",
                padding: "0.5rem 1rem",
                border: "1px solid black",
                borderImageSource: "linear-gradient(to right, transparent 0%, #b7b7b7 30% 65%, transparent 100%)",
                borderImageSlice: 1,
                borderTop: "0px",
            }}>
                <div style={{display: "flex", flexDirection: "row", gap: "0.5rem"}}>
                    <div style={{width: "8rem"}}>Date création:</div>
                    <div style={{color: "rgba(0,0,0,.70)"}}>{format(formData?.formData?.dateCreation, "yyyy-MM-dd HH:mm")}</div>
                </div>
                <div style={{display: "flex", flexDirection: "row", gap: "0.5rem"}}>
                    <div style={{width: "8rem"}}>Créé Par:</div>
                    <div style={{color: "rgba(0,0,0,.70)"}}>{getUsagerNamebyId(formData.formData?.idUsagerCreation)}</div>
                </div>
            </div>
            <div className={"dx-field-item-label-text"} style={{
                display: "flex",
                flexDirection: "column",
                padding: "0.5rem 1rem",
                border: "1px solid black",
                borderImageSource: "linear-gradient(to right, transparent 0%, #b7b7b7 20% 80%, transparent 100%)",
                borderImageSlice: 1,
                borderTop: "0px",
            }}>
                <div style={{display: "flex", flexDirection: "row", gap: "0.5rem"}}>
                    <div style={{width: "8rem"}}>Date modification:</div>
                    <div style={{color: "rgba(0,0,0,.70)"}}>{format(formData?.formData?.dateCreation, "yyyy-MM-dd HH:mm")}</div>
                </div>
                <div style={{display: "flex", flexDirection: "row", gap: "0.5rem"}}>
                    <div style={{width: "8rem"}}>Modifié Par:</div>
                    <div style={{color: "rgba(0,0,0,.70)"}}>{getUsagerNamebyId(formData.formData?.idUsagerModification)}</div>
                </div>
            </div>
            <div className={"dx-field-item-label-text"} style={{
                display: "flex",
                flexDirection: "column",
                padding: "0.5rem 1rem",
            }}>
                <div style={{display: "flex", flexDirection: "row", gap: "0.5rem"}}>
                    <div style={{width: "8rem"}}>Date supression:</div>
                    <div style={{color: "rgba(0,0,0,.70)"}}>{formData?.formData?.dateSuppression ? format(formData?.formData?.dateSuppression, "yyyy-MM-dd HH:mm") : null}</div>
                </div>
                <div style={{display: "flex", flexDirection: "row", gap: "0.5rem"}}>
                    <div style={{width: "8rem"}}>Supprimé Par:</div>
                    <div style={{color: "rgba(0,0,0,.70)"}}>{getUsagerNamebyId(formData.formData?.idUsagerSuppression)}</div>
                </div>
            </div>
        </div>
        /*
                <Form style={{flex: 1}} className={"forms"} readOnly={true} formData={formData.formData} alignItemLabels={true} labelLocation={"left"}>
                    <GroupItem>
                        <GroupItem>
                            <SimpleItem dataField={"dateCreation"} editorType={"dxDateBox"} editorOptions={{...dateTimeOptions,}}>
                                <Label text={"Date de création"}/>
                            </SimpleItem>
                            <SimpleItem render={() => <div>{getUsagerNamebyId(formData.formData?.idUsagerCreation)}</div>}>
                                <Label text={"Créé par"}/>
                            </SimpleItem>

                            <SimpleItem dataField={"dateModification"} editorType={"dxDateBox"} editorOptions={dateTimeOptions}>
                                <Label text={"Date de modification"}/>
                            </SimpleItem>
                            <SimpleItem render={() => <div>{getUsagerNamebyId(formData.formData?.idUsagerModification)}</div>}>
                                <Label text={"Modifié par"}/>
                            </SimpleItem>
                        </GroupItem>
                    </GroupItem>
                </Form>*/
    );
}